import { EducationProviderService } from '@/services/education-provider';
import { ApiReactQueryOptions } from '@/types/api';
import { ApiIndividualEducationProvider } from '@/types/education-provider';
import { useQueries } from '@tanstack/react-query';

export function useIndividualEducationProviders(
  educationProviderIds: string[],
  options?: ApiReactQueryOptions<ApiIndividualEducationProvider>,
) {
  return useQueries({
    queries: educationProviderIds.map(id => ({
      queryKey: [EducationProviderService.PATH, id],
      queryFn: () => EducationProviderService.getEducationProvider(id),
      ...options,
    })),
    combine: results => {
      return {
        data: results.map(result => result.data?.data),
        isLoading: results.some(result => result.isLoading),
        isError: results.some(result => result.isError),
        error: results.find(result => result.isError)?.error,
      };
    },
  });
}
